module.exports = __webpack_public_path__ + "img/2024-02-13c_2.56e2730e.jpg";